import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { from, map } from 'rxjs';
import { AuthService } from '../../auth/components/services/auth.service';

/**
 * Guard for the root "/" path only.
 * Redirects to dashboard if user has session, otherwise to login.
 */
export const rootRedirectGuard = () => {
    const authService = inject(AuthService);
    const router = inject(Router);

    return from(authService.app.auth.getSession()).pipe(
        map(({ data }) => {
            if (data.session) {
                router.navigate(['/dashboard']);
            } else {
                router.navigate(['/auth/login']);
            }
            return false; // Always return false since we're redirecting
        })
    );
};
